module.exports = __webpack_public_path__ + "img/banner3.39d37efb.jpg";